import { ActivityTargetAge, Activity, ActivityKeyword } from '~/schemes';

/**
 * アクティビティフィルタ条件モデル
 */
export interface ActivitiesFilterModel {
  /**
   * 対象年齢のリスト
   *
   * @see {@link ActivityTargetAge}
   */
  targetAges: ActivityTargetAge[];

  /** 期間（月）1-12 */
  month: string | null;

  /**
   * キーワードの値のリスト
   *
   * @see {@link ActivityKeyword}
   */
  keywords: ActivityKeyword['value'][];
}

/**
 * フィルタ処理用に開催期間が拡張されたアクティビティ
 */
export interface FilterableActivity extends Activity {
  /**
   * 計算済みの開催期間
   *
   * * 公開データの値はstringになっているのでDateインスタンスに変換する
   * * 以下のようなことを書いていたけどなんだかわからないのでその仕様のまま残しておく
   *   * FROM, TOはシステムが返却するデータをちゃんとISO値でタイムゾーンオフセットも返却してもらう
   *   * 暫定的に全てJSTで扱う（SSR<>CLIENTの双方で時間が食い違うのを防止する）
   */
  computedPeriod: {
    /** 開始日（JSTで正規化されたDateインスタンス） */
    from: Date | null;
    /** 終了日（JSTで正規化されたDateインスタンス） */
    to: Date | null;
  } | null;
}

/**
 * アクティビティフィルタ条件を生成する
 */
export function createActivitiesFilterModel(): ActivitiesFilterModel {
  return {
    targetAges: [],
    month: null,
    keywords: [],
  };
}
